import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { isSelenium } from '../utils/storage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const propTypes = {
  children: PropTypes.node,
  hasSeen: PropTypes.bool,
  dismiss: PropTypes.func.isRequired,
  trackInteraction: PropTypes.func.isRequired,
  hasQuery: PropTypes.bool
};
const AdvancedSearchPopover = ({
  children,
  hasSeen,
  dismiss,
  trackInteraction,
  hasQuery
}) => /*#__PURE__*/_jsx(UIPopover, {
  open: hasSeen === false && hasQuery !== false && !isSelenium(),
  showCloseButton: true,
  use: "shepherd",
  width: 300,
  onOpenChange: dismiss,
  placement: "bottom",
  "data-test-id": "advanced-search-popover",
  content: {
    header: /*#__PURE__*/_jsx("h4", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.advancedSearch.header"
      })
    }),
    body: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.advancedSearch.body"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
        href: "https://knowledge.hubspot.com/files/organize-edit-and-delete-files",
        external: true,
        onClick: () => trackInteraction('fileManagerExploreFiles', 'advanced-search-learnMore'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerCore.advancedSearch.learnMore"
        })
      })]
    })
  },
  children: /*#__PURE__*/_jsx(_Fragment, {
    children: children
  })
});
AdvancedSearchPopover.propTypes = propTypes;
export default AdvancedSearchPopover;